import { createMuiTheme } from '@material-ui/core/styles';
import ShowcaseSiteShell from 'src/components/site/shells/ShowcaseSiteShell';
import { ROUTE_ABOUT, ROUTE_CONTACT, ROUTE_HOME, ROUTE_SERVICES, ROUTE_STORE } from 'src/config/routes';
import { coreSiteRoutes } from 'src/config/sites/coreRoutes';
import { SiteDefinition } from '../../config/sites/SiteDefinition';
import { createModuleInit } from './moduleInit';

const showcaseSite: SiteDefinition = {
    id: 'showcase',
    label: 'Showcase Experience',
    description: 'Demonstrates a themed shell with configurable navigation.',
    hostnames: ['showcase.localhost', 'showcase.lamante.test'],
    routes: coreSiteRoutes,
    navigation: [
        {
            id: 'primary',
            label: 'Explore',
            items: [
                { id: 'nav-home', label: 'Home', route: ROUTE_HOME },
                { id: 'nav-store', label: 'Store', route: ROUTE_STORE },
                { id: 'nav-services', label: 'Services', route: ROUTE_SERVICES },
            ],
        },
        {
            id: 'secondary',
            label: 'Company',
            items: [
                { id: 'nav-about', label: 'About', route: ROUTE_ABOUT },
                { id: 'nav-contact', label: 'Contact', route: ROUTE_CONTACT },
            ],
        },
    ],
    shell: ShowcaseSiteShell,
    init: createModuleInit(),
    theme: outerTheme => {
        const buttonTypography = outerTheme.typography?.button ?? {};

        return createMuiTheme(outerTheme, {
            palette: {
                primary: {
                    main: '#0b3d91',
                },
                secondary: {
                    main: '#f77f00',
                },
                background: {
                    default: '#fffaf3',
                },
            },
            shape: {
                borderRadius: 12,
            },
            typography: {
                ...outerTheme.typography,
                button: {
                    ...buttonTypography,
                    textTransform: 'uppercase',
                    letterSpacing: '0.08em',
                },
            },
        });
    },
};

export default showcaseSite;
